function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M6.152 1H1.36v.979h.365v8.99a2.032 2.032 0 004.063 0v-8.99h.365V1zm-.96 9.97a1.435 1.435 0 01-2.869.001v-.522h.987v-.575h-.987V8.862h.987v-.59h-.987V7.26h.987v-.589h-.987V5.66h.987v-.575h-.987V4.07h.987v-.575h-.987V1.971h2.87v8.998zM12.64 1H7.847v.979h.365v8.99a2.032 2.032 0 004.063 0v-8.99h.365V1zm-.96 9.97a1.435 1.435 0 01-2.87.001v-.522h.987v-.575h-.986V8.862h.986v-.59h-.986V7.26h.986v-.589h-.986V5.66h.986v-.575h-.986V4.07h.986v-.575h-.986V1.971h2.869v8.998z",
  fill: "currentColor"
});

var SvgEmptyTubes = function SvgEmptyTubes(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    fill: "none"
  }, props), _ref);
};

export default SvgEmptyTubes;